'use strict';

let CustomError=require('pulsar-utils/dist-es6/customError');let

SessionExpiredError=class SessionExpiredError extends CustomError{
constructor(){
super('SessionExpiredError');
}};


module.exports=SessionExpiredError;
//# sourceMappingURL=sessionExpiredError.js.map
